import React from 'react';
import { SegmentDivider, SegmentDividerContainer } from './styles';
import { DividerProps } from './types';

export const Divider = React.forwardRef<HTMLDivElement, DividerProps>((props, ref) => (
  <SegmentDividerContainer className={props.className}>
    <SegmentDivider ref={ref} />
  </SegmentDividerContainer>
));
